

export const listThingNamesRedux = (
  includePrototypes: boolean,
  actionType: string,

) => {
  window.parent.primingcloudRedux.thing.listThingNames(
    includePrototypes,
    actionType,

  )
}

export const listThingsRedux = (
  actionType: string,

) => {
  window.parent.primingcloudRedux.thing.listThings(
    actionType,

  )
}

export const loadThingRedux = (
  thingId: number,
  actionType: string
) => {
  window.parent.primingcloudRedux.thing.loadThing(
    thingId,
    actionType
  )
}

export const loadThingNameRedux = (
  thingId: number,
  actionType: string
) => {
  window.parent.primingcloudRedux.thing.loadThingName(
    thingId,
    actionType
  );
}

export const updateThingRedux = (
  thing: any,
  actionType: string,

) => {
  window.parent.primingcloudRedux.thing.updateThing(
    thing,
    actionType,

  )
}

export const deleteThingRedux = (
  customer: string,
  application: string,
  thingId: number,
  actionType: string,

) => {
  window.parent.primingcloudRedux.thing.deleteThing(
    customer,
    application,
    thingId,
    actionType,

  )
}